module.exports = __webpack_public_path__ + "static/media/md-crop.988702a3.svg";